import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { SessionActions } from '../store/session'

export default function LogoutPage() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(SessionActions.logout())
  }, [dispatch])

  return null
}
